import * as React from 'react';

import { cn } from '@/lib/util/cn';

/**
 * The ONE page-content wrapper. Full width with consistent gutters — pages
 * previously declared their own `mx-auto max-w-[1500|1600|1800px] px-…`
 * wrappers, which capped wide screens differently per page and left some
 * (option chains) with no gutter at all. A trading console wants the width:
 * data-dense tables get every pixel, and the shared gutter keeps pages
 * uniform.
 */
export function PageContainer({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) {
  return <div className={cn('w-full min-w-0 px-5 py-5', className)}>{children}</div>;
}
